import React, { Component, useState, useEffect } from 'react'
import { Container, Grid, Typography, Box, Avatar, Alert, Button, TextField, Link } from "@mui/material/";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import { Link as RouterLink } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Copyright } from '../components/Copyright';
import CssBaseline from '@mui/material/CssBaseline';

import { auth, translateFirebaseError, firebaseConfig } from "../firebase";

const theme = createTheme();

export const LoginPage = () => {
    const { login } = useAuth();
    const [error, setError] = useState("");

    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        setError("");
        try {
            await login(data.get("email"), data.get("password"));
            // navigate("/dashboard/profile", { replace: true });
        } catch (err) {
            console.log("Error:")
            console.log(err);


            setError(translateFirebaseError(err));
        }
    };

    return (
        <Grid container component="main" sx={{ height: '100vh' }}>
            <CssBaseline />
            <Grid
                item
                xs={false}
                sm={4}
                md={7}
                sx={{
                    backgroundImage: 'url(/img/login.jpg)',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: (t) =>
                        t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
            />
            <Container component="main" maxWidth="xs">
                <Box
                    sx={{
                        marginTop: 8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center"
                    }}
                >
                    {/* Show project-specific logo */}
                    <Box sx={{ mb: 2 }}>
                        {firebaseConfig.projectId === "litport-schoeningh" ? (
                            <img 
                                src="/img/logo_schoeningh.svg" 
                                alt="Schöningh Logo" 
                                style={{ height: '60px', width: 'auto' }}
                            />
                        ) : firebaseConfig.projectId === "litport-heine-c2471" ? (
                            <img 
                                src="/img/logo_heine.svg" 
                                alt="Heine Logo" 
                                style={{ height: '60px', width: 'auto' }}
                            />
                        ) : (
                            <img 
                                src="/img/B+R einzeilig 4c.svg" 
                                alt="Litport Logo" 
                                style={{ height: '60px', width: 'auto' }}
                            />
                        )}
                    </Box>
                    <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Bei Litport anmelden
                    </Typography>
                    {error && <div variant="danger">{error}</div>}
                    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                        {/* 
                        <TextField
                            required
                            fullWidth
                            id="accountID"
                            label="Kundennummer"
                            name="accountID"
                            autoComplete=""
                        /> */}
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label="E-Mail Adresse"
                            name="email"
                            autoComplete="email"
                            autoFocus
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Passwort"
                            type="password"
                            id="password"
                            autoComplete="current-password"
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                        >
                            Anmelden
                        </Button>
                        {error && <Alert severity="error">{error}</Alert>}

                        <Grid container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
                            {firebaseConfig.registrationEnabled && (
                            <Grid item xs={12}>
                                <Typography variant="body2" color="text.secondary" textAlign="center">
                                    Sie haben noch keine Zugangsdaten?{' '}
                                    <Link component={RouterLink} to="/register" variant="body2">
                                        Hier anfordern!
                                    </Link>
                                </Typography>
                            </Grid>
                            )}
                            <Grid item xs={12}>
                                <Typography variant="body2" color="text.secondary" textAlign="center">
                                    Passwort vergessen?{' '}
                                    <Link component={RouterLink} to="/password-reset" variant="body2">
                                        Passwort zurücksetzen
                                    </Link>
                                </Typography>
                            </Grid>
                        </Grid>

                    </Box>
                </Box>
                {/* <Copyright sx={{ mt: 5 }} /> */}
            </Container>
        </Grid>
    );
};
